import { render, staticRenderFns } from "./Beacon.vue?vue&type=template&id=27af3635"
import script from "./Beacon.vue?vue&type=script&lang=js"
export * from "./Beacon.vue?vue&type=script&lang=js"
import style0 from "./Beacon.vue?vue&type=style&index=0&id=27af3635&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports